// src/datosCongresos.js

export const congresosAnterioresData = [
  {
    id: 'congreso-2022',
    title: 'XXVIII Congreso Internacional CAES (2022)',
    verMas: 'VER CONGRESO +',
    lema: 'Recursos Humanos y Calidad en Salud',
    descripcion: 'En la edición de 2022, el congreso se centró en los desafíos de la gestión de recursos humanos en el sector salud y la importancia de mantener altos estándares de calidad en la atención al paciente, especialmente tras las lecciones aprendidas durante la pandemia.',
    youtubeVideoId: 'BCfmk_MQ294'
  },
  {
    id: 'encuentro-2022',
    title: 'III Encuentro Nacional de Clínicas, Sanatorios y Hospitales (2022)',
    verMas: 'VER III ENCUENTRO NACIONAL DE CLÍNICAS, SANATORIOS Y HOSPITALES +',
    lema: '',
    descripcion: 'Tercer encuentro nacional enfocado en la articulación y desafíos de las clínicas, sanatorios y hospitales en el contexto actual.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2021',
    title: 'XXVII Congreso Internacional (2021)',
    verMas: 'VER CONGRESO +',
    lema: 'Costos Sanatoriales y Gestión de la Pandemia',
    descripcion: 'El congreso de 2021 abordó el impacto económico de la pandemia en las instituciones de salud, analizando los costos sanatoriales y las estrategias de gestión que emergieron para hacer frente a una crisis sin precedentes.',
    youtubeVideoId: 'L_LUpnjgPso'
  },
  {
    id: 'congreso-2020',
    title: 'XXVI Congreso Internacional (2020)',
    verMas: 'VER CONGRESO +',
    lema: 'Pandemia Covid-19. Las consecuencias en el Sector de la Salud',
    descripcion: 'Una edición histórica realizada en formato virtual, que se enfocó en las consecuencias inmediatas y a largo plazo de la pandemia de COVID-19 en el sistema de salud global y argentino.',
    youtubeVideoId: '3tmd-ClpJxA'
  },
  {
    id: 'congreso-2019',
    title: 'XXV Congreso Internacional (2019)',
    verMas: 'VER PROGRAMAS XXV CONGRESO INTERNACIONAL CAES + ENCUENTRO NACIONAL DE CLÍNICAS',
    lema: 'Política de Estado. Innovación y Salud',
    descripcion: 'Cobertura del XXV Congreso Internacional CAES, centrado en la innovación y la equidad en el sector salud.',
    youtubeVideoId: ''
  },
  
  {
    id: 'congreso-2018',
    title: 'XXIV Congreso Internacional (2018)',
    verMas: 'VER CONGRESO +',
    lema: 'Educación y Salud',
    descripcion: 'Edición 2018 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2017',
    title: 'XXIII Congreso Internacional (2017)',
    verMas: 'VER CONGRESO +',
    lema: 'El Hombre y el Derecho a la Salud',
    descripcion: 'Edición 2017 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2016',
    title: 'XXII Congreso Internacional (2016)',
    verMas: 'VER CONGRESO +',
    lema: 'Aportes para Mejorar la Atención',
    descripcion: 'Edición 2016 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2015',
    title: 'XXI Congreso Internacional (2015)',
    verMas: 'VER CONGRESO +',
    lema: 'Salud, Política de Estado',
    descripcion: 'Edición 2015 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2014',
    title: 'XX Congreso Internacional (2014)',
    verMas: 'VER CONGRESO +',
    lema: 'Los Resultados de la Inequidad',
    descripcion: 'Edición 2014 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2013',
    title: 'XIX Congreso Internacional (2013)',
    verMas: 'VER CONGRESO +',
    lema: 'Redes Integradas de Servicios de Salud',
    descripcion: 'Edición 2013 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'precongreso-santiago-2013',
    title: 'Pre Congreso Santiago del Estero (2013)',
    verMas: 'VER PRE-CONGRESO +',
    lema: '',
    descripcion: 'Pre congreso realizado en Santiago del Estero en 2013.',
    youtubeVideoId: ''
  },
  {
    id: 'precongreso-sanjuan-2013',
    title: 'Pre Congreso San Juan (2013)',
    verMas: 'VER PRE-CONGRESO +',
    lema: '',
    descripcion: 'Pre congreso realizado en San Juan en 2013.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2012',
    title: 'XVIII Congreso Internacional (2012)',
    verMas: 'VER CONGRESO +',
    lema: 'Los Determinantes Sociales',
    descripcion: 'Edición 2012 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2011',
    title: 'XVII Congreso Internacional (2011)',
    verMas: 'VER CONGRESO +',
    lema: 'Propuestas Sanitarias para el Nuevo Ciclo de Gobierno',
    descripcion: 'Edición 2011 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2010',
    title: 'XVI Congreso Internacional (2010)',
    verMas: 'VER CONGRESO +',
    lema: 'Equidad y Exclusión Social',
    descripcion: 'Edición 2010 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2009',
    title: 'XV Congreso Internacional (2009)',
    verMas: 'VER CONGRESO +',
    lema: 'La Integración Estatal Privada',
    descripcion: 'Edición 2009 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2008',
    title: 'XIV Congreso Internacional (2008)',
    verMas: 'VER CONGRESO +',
    lema: 'La Seguridad del Paciente',
    descripcion: 'Edición 2008 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2007',
    title: 'XIII Congreso Internacional (2007)',
    verMas: 'VER CONGRESO +',
    lema: 'Aportes para la Nueva Etapa de Gobierno',
    descripcion: 'Edición 2007 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2006',
    title: 'XII Congreso Internacional (2006)',
    verMas: 'VER CONGRESO +',
    lema: 'Aportes para la Reforma',
    descripcion: 'Edición 2006 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2005',
    title: 'XI Congreso Internacional (2005)',
    verMas: 'VER CONGRESO +',
    lema: 'Salud y Desarrollo Social',
    descripcion: 'Edición 2005 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2004',
    title: 'X Congreso Internacional (2004)',
    verMas: 'VER CONGRESO +',
    lema: 'El Plan Federal de Salud',
    descripcion: 'Edición 2004 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2003',
    title: 'IX Congreso Internacional (2003)',
    verMas: 'VER CONGRESO +',
    lema: 'Salud y Productividad Social',
    descripcion: 'Edición 2003 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2002',
    title: 'VIII Congreso Internacional (2002)',
    verMas: 'VER CONGRESO +',
    lema: 'La Salud como dinamizadora de la Economía',
    descripcion: 'Edición 2002 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2001',
    title: 'VII Congreso Internacional (2001)',
    verMas: 'VER CONGRESO +',
    lema: 'Salud y Desarrollo',
    descripcion: 'Edición 2001 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-2000',
    title: 'VI Congreso Internacional (2000)',
    verMas: 'VER CONGRESO +',
    lema: 'Las Políticas de Salud',
    descripcion: 'Edición 2000 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-1999',
    title: 'V Congreso Internacional (1999)',
    verMas: 'VER CONGRESO +',
    lema: 'Las Asignaturas Pendientes',
    descripcion: 'Edición 1999 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-1998',
    title: 'IV Congreso Internacional (1998)',
    verMas: 'VER CONGRESO +',
    lema: 'El Derecho a la Salud y los Recursos',
    descripcion: 'Edición 1998 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-1997',
    title: 'III Congreso Internacional (1997)',
    verMas: 'VER CONGRESO +',
    lema: 'Sociedad, Desregulación y Mercado',
    descripcion: 'Edición 1997 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-1996',
    title: 'II Congreso Internacional (1996)',
    verMas: 'VER CONGRESO +',
    lema: 'El Modelo Sanitario',
    descripcion: 'Edición 1996 del Congreso Internacional CAES.',
    youtubeVideoId: ''
  },
  {
    id: 'congreso-1995',
    title: 'I Congreso Internacional (1995)',
    verMas: 'VER CONGRESO +',
    lema: 'Propuestas para la Reforma',
    descripcion: 'El primer congreso sentó las bases para un debate nacional sobre la necesaria reforma del sistema de salud, reuniendo a expertos para delinear las primeras propuestas.',
    youtubeVideoId: 'yPYZpwSpKmA'
  }
];